/**
 * Whether two regime tree ids name the same regime. Ids may or may not carry a namespace
 * suffix ("live|abc:sfg20/tree" or "live|abc"): the regime picker's options have one, and
 * a scenario's stored regime id may not, so they are compared without it.
 *
 * @param {string} a
 * @param {string} b
 * @returns {boolean}
 */
export function isSameRegimeId(a, b) {
    return !!a && !!b && withoutNamespace(a) === withoutNamespace(b)
}

function withoutNamespace(id) {
    return String(id).split(":")[0]
}
